import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderInfo',
			dom: {
				count: '#yotaOrderInfoCount',
				price: '#yotaOrderInfoPrice',
				minus: '#yotaOrderInfoMinus',
				plus: '#yotaOrderInfoPlus'
			},
			callback: {
				set: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$count = this.$el.find(this.options.dom.count);
		this.$price = this.$el.find(this.options.dom.price);
		this.$minus = this.$el.find(this.options.dom.minus);
		this.$plus = this.$el.find(this.options.dom.plus);
		return this;
	}

	getPrice() {
		return parseInt(this.$price.data('price'), 10);
	}

	getCount() {
		return parseInt(this.$count.data('count'), 10);
	}

	set(count) {
		const price = this.$price.data('price');
		this.$count
			.data('count', count)
			.html(count);
		this.$price.html(price * count);

		if (typeof this.options.callback.set == 'function') {
			this.options.callback.set(count, 'info');
		}
	}

	plus(event) {
		let count = parseInt(this.$count.data('count'), 10);
		const max = parseInt(this.$plus.data('max'), 10);
		if (count < max) {
			count++;
		}
		this.set(count);
		event.preventDefault();
	}

	minus(event) {
		let count = parseInt(this.$count.data('count'), 10);
		const min = parseInt(this.$minus.data('min'), 10);
		if (count > min) {
			count--;
		}
		this.set(count);
		event.preventDefault();
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.$minus.on('click', self.minus.bind(self));
			self.$plus.on('click', self.plus.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/info/info.js